import { render, staticRenderFns } from "./BloqueadoTable.vue?vue&type=template&id=013b838d&scoped=true"
import script from "./BloqueadoTable.vue?vue&type=script&lang=js"
export * from "./BloqueadoTable.vue?vue&type=script&lang=js"
import style0 from "./BloqueadoTable.vue?vue&type=style&index=0&id=013b838d&prod&lang=scss"
import style1 from "./BloqueadoTable.vue?vue&type=style&index=1&id=013b838d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013b838d",
  null
  
)

export default component.exports